import { FC } from 'react';
import { ContactLogin } from './ContactLogin/ContactLogin';

export const ContactLoginPage: FC = () => {
  return <ContactLogin />;
};
